import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';

// import DataUtilities from "../../../utilities/common_utilities";
import SelectStringBox from "@components/input/selects/SelectStringBox";
import StringBox from "@components/input/strings/StringBox";
import DeleteButton from "@components/input/buttons/DeleteButton";
import LoadingBox from "@components/input/LoadingBox";

interface Props {
  name1: string;
  name2: string;
  the_key: string;
  value: string | number;
  keys?: string[];
  // string_hash?: { [key: string]: string };
  // num_hash?: { [key: string]: number };
  disabled?: boolean;
  onChange: (key: string, value: string | number) => void;
  onDelete?: () => void;
}

// const common_util = DataUtilities.getInstance();

export default function SelectStringToHashBox({
  name1,
  name2,
  the_key,
  value,
  keys,
  // string_hash,
  // num_hash,
  disabled = false,
  onChange,
  onDelete
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [use_keys, setKeys] = useState<string[]>([]);
  // const [value_options, setValueOptions] = useState<string[] | undefined>(undefined);
  const [my_key, setKey] = useState("");
  const [my_value, setValue] = useState(value);

  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      setKey(the_key);
      if (keys) {
        setKeys(keys);
      // } else if (string_hash) {
      //   setKeys(Object.keys(string_hash));
      // } else if (num_hash) {
      //   setKeys(Object.keys(num_hash));
      }
    }
  }, [fetched, keys, the_key]);

  if (!fetched) {
    return (<LoadingBox />);
  } else {
    // console.log(use_keys);
    // console.log(my_key);
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: onDelete ? 5 : 6
          }}>
          <SelectStringBox
            name={name1}
            options={use_keys}
            value={my_key}
            disabled={disabled}
            onChange={(changed: string) => {
              setKey(changed);
              onChange(changed, my_value);
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: onDelete ? 5 : 6
          }}>
          <StringBox
            name={name2}
            value={`${my_value}`}
            disabled={disabled}
            type={ typeof value === "number" ? "number" : "" }
            onBlur={(changed: string) => {
              const new_value = typeof value === "number" ? +changed : changed;
              setValue(new_value);
              onChange(my_key, new_value);
            }}
          />
        </Grid>
        { onDelete &&
          <Grid
            size={{
              xs: 2
            }}>
            <DeleteButton
              no_confirm
              onClick={onDelete}
            />
          </Grid>
        }
      </Grid>
    );
  }
}
